module.exports = __webpack_public_path__ + "img/bobbibrown_logo_footer.fdd140f3.png";